import { fetchCA, fetchBQ } from 'helpers/utils'

export const apiFetchFootprints = (id) =>
  fetchBQ(`/footprints/${encodeURIComponent(id)}`)

export const apiFetchFootprintsSession = async (id, customer) => {
  const response = await fetchCA(
    `/footprints/${encodeURIComponent(id)}/${encodeURIComponent(customer)}`
  )

  if (!response) {
    throw new Error('Footprints session not found')
  }

  if (!response.app_instance_id) {
    throw new Error('Footprints session missing app instance id')
  }

  return response
}

export const apiUpdateFootprints = (id, body) =>
  fetchCA(`/footprints/${encodeURIComponent(id)}`, {}, 'PATCH', body)

export const apiCreateFootprints = (body) =>
  fetchCA(`/footprints`, {}, 'POST', body)
